<script>
  import { domainName, record } from '../stores.js';
  import ContactUsForm from '../ContactUsForm.svelte';

  let createSpf = false;
</script>

<div class="record-box record-404 text-center">
  <div id="headingRaw" class="box-label">
    <h5 class="mb-3">No SPF record found for <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <p>This domain does not have a TXT record published.</p>
    <button on:click|preventDefault={() => createSpf = true} disabled={createSpf} class="btn btn-1" id="create-spf">Create SPF Record</button>
  </div>
  {#if createSpf}
    <div class="box-detail found-no-record">
      <ContactUsForm />
    </div>
  {/if}
</div>

<style>

</style>
